

import {
  FETCH_WORKLEVEL_TYPE_REQUEST,
  FETCH_WORKLEVEL_TYPE_SUCCESS,
  FETCH_WORKLEVEL_TYPE_FAILURE,
  SELECT_WORKLEVEL,
} from '../types';

const initialState = {
  // workLevel: [],
  workLevelList: [],
  selectedworkLevelId: null,
  loading: false,
  error: null,
};

const workLevelReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WORKLEVEL_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_WORKLEVEL_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        workLevelList: action.payload,
      };
    case FETCH_WORKLEVEL_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SELECT_WORKLEVEL:
      return {
        ...state,
        selectedworkLevelId: action.payload,
      };
    default:
      return state;
  }
};

export default workLevelReducer;

